import React, { useEffect } from 'react';
import { t } from '@lingui/macro';
import { useRouter } from 'next/router';
import { RegistrationFormDE } from 'components/Registration/RegistrationFormDE';
import { RegistrationFormUK } from 'components/Registration/RegistrationFormUK';
import { useLocale } from 'hooks/useLocale';
import { getCookie } from 'utils/cookieHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { BaseLayout } from '../components/Layout/BaseLayout/BaseLayout';

const Register = () => {
  const { isDE } = useLocale();
  const router = useRouter();
  const isLoggedIn = getCookie('isLoggedIn');

  useEffect(() => {
    // Cookie isLoggedIn comes as a string | null and not a boolean
    if (isLoggedIn === 'True') {
      router.push(PATH_NAMES.home());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BaseLayout pageTitle={t`Register | Introducer Portal`}>
      {isDE ? <RegistrationFormDE /> : <RegistrationFormUK />}
    </BaseLayout>
  );
};

export default Register;
